/* eslint-disable no-restricted-syntax */
import axios, { AxiosRequestConfig } from 'axios';
import { addQueryToUrl } from '@/utils/utils';
import request from '@/utils/request';
import config from '@/constants/env.config';

const API = config.APP_API;

class Http {
  /**
   * get 请求
   * @param url
   * @param params
   * @param config
   */
  async get<T, K>(
    data: {
      action: string;
      params: Record<string, any>,
      config?: Record<string, any>,
      useApiPrefix?: boolean
      needLogin?: boolean
    },
  ) {
    const {
      action,
      params,
      config,
      useApiPrefix = true,
      needLogin = false,
    } = data || {};
    const curUrl = `${API}${useApiPrefix ? '/api' : ''}/${action}`;
    return request.get(addQueryToUrl(curUrl, ({
      action,
    })), config || {});
  }

  /**
   * post 请求
   * @param url
   * @param data
   * @param config
   */
  async post(
    param: {
      action: string;
      data: any;
      config?: AxiosRequestConfig<any> | undefined;
      useApiPrefix?: boolean;
      isUploadFile?: boolean;
      needLogin?: boolean
    },
  ): Promise<any> {
    const {
      action,
      data,
      config,
      useApiPrefix = true,
      isUploadFile = false,
    } = param || {};
    const curUrl = `${API}${useApiPrefix ? '/api' : ''}/${action}`;
    return request.post(curUrl, {
      action,
      isUploadFile,
      ...(data || {}),
    }, config);
  }
}

export default new Http();
